module.exports = __webpack_public_path__ + "static/media/dike_history_2013_netherlands.cfc43748.jpeg";